<div class="faqgroup mb-2 mt-3">
  @if (faqGroup.faqEntries.length > 0) {
    <div class="faqgroup__container">
      <h5 class="faqgroup__title fw-bold">{{ faqGroup.name }}</h5>
      <p class="faqgroup__description fs-6">{{ faqGroup?.description }}</p>
      <div class="faqgroup__entries ms-1">
        @for (entry of faqGroup.faqEntries; track entry) {
          <div class="faqgroup__entry">
            <mat-expansion-panel class="faqgroup__panel">
              <mat-expansion-panel-header class="faqgroup__panel-header">
                <mat-panel-title class="faqgroup__panel-title">
                  <p class="faqgroup__question fs-6 mb-0 fw-bold">{{ entry.question }}</p>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p class="faqgroup__answer" [innerHTML]="entry.answer"></p>
            </mat-expansion-panel>
          </div>
        }
      </div>
    </div>
  }
</div>
